"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = void 0;
const Util_1 = require("./util/Util");
class Observable {
    constructor(state, parentObservable, parentKey) {
        Observable.register(this, parentObservable, parentKey);
        Observable.set(this, state, false);
    }
    static register(obs, parentObservable, parentKey) {
        if (this.meta.has(obs))
            return;
        this.meta.set(obs, {
            listenners: [],
            parentObservable: parentObservable,
            parentKey: parentKey,
            state: {}
        });
    }
    static getMeta(obs) {
        const meta = this.meta.get(obs);
        if (!meta)
            throw new ReferenceError("Observable not exists!");
        return meta;
    }
    static subscribe(obs, ...listeners) {
        const meta = this.getMeta(obs);
        meta.listenners.push(...listeners.map(listener => ({
            properties: null,
            handler: listener
        })));
        this.meta.set(obs, meta);
    }
    static notify(obs, oldState) {
        const meta = this.getMeta(obs);
        const old = meta.parentObservable
            ? oldState
            : oldState.map(([key, value]) => [
                key.join("."),
                value
            ]);
        meta.listenners.forEach(listener => {
            if (!listener.properties ||
                listener.properties.find(k => {
                    if (Array.isArray(old[0])) {
                        return old[0].includes(k);
                    }
                    return old[0] === k;
                })) {
                return listener.handler(obs, old);
            }
        });
        if (meta.parentObservable) {
            const oldStatePath = oldState.map(state => {
                state[0] = [meta.parentKey].concat(state[0]);
                return state;
            });
            this.notify(meta.parentObservable, oldStatePath);
        }
    }
    static set(obs, state, notify = true) {
        const meta = this.getMeta(obs);
        const old = [];
        for (let [key, value] of Object.entries(state)) {
            if (Util_1.isObject(value)) {
                value = new Observable(value, obs, key);
            }
            // Define new properties
            if (!(key in obs)) {
                Object.defineProperty(obs, key, {
                    enumerable: true,
                    set(v) {
                        Observable.set(obs, { [key]: v });
                    },
                    get() {
                        return Observable.getState(obs)[key];
                    }
                });
            }
            meta.state[key] = value;
            old.push([[key], value]);
        }
        this.meta.set(obs, meta);
        if (notify)
            this.notify(obs, old);
    }
    static getState(obs) {
        const meta = this.getMeta(obs);
        return meta && meta.state;
    }
    static watch(obs, properties, ...listeners) {
        const meta = this.getMeta(obs);
        meta.listenners.push(...listeners.map(listener => ({
            properties: properties,
            handler: listener
        })));
    }
    static create(state) {
        return new Observable(state);
    }
}
exports.Observable = Observable;
Observable.meta = new WeakMap();
